import { useEffect, useRef } from 'react'
import { Button, Stack, Text, Title } from '@common/ui'
import apiBaseUrl from '../../io/api/baseUrl'
import Center from '../../components/layout/Center'

const SignInPage = () => {
  const hasOpenedTab = useRef(false)

  const downloadUrl = `${apiBaseUrl}updates/latest-eidu-field?type=support`

  const openDownloadUrl = () => {
    window.open(downloadUrl, '_blank')
  }

  useEffect(() => {
    if (!hasOpenedTab.current) {
      openDownloadUrl()
      hasOpenedTab.current = true
    }
  }, [])

  return (
    <Center style={{ height: '100vh' }}>
      <Stack gap="xl" align="center">
        <img src="/logoGreen.png" alt="EIDU Logo" width="240" />
        <div
          style={{
            width: '50%',
            height: '4px',
            background: 'linear-gradient(90deg, transparent, #003223, transparent)',
            marginBlock: 20,
          }}
        />
        <Title order={3} ta="center">
          Downloading Field App in new tab
        </Title>
        <Text ta="center" c="dimmed">
          If the download did not start automatically, please{' '}
          <Button
            onClick={openDownloadUrl}
            variant="subtle"
            fw={700}
            style={{ minWidth: 'auto', padding: '0 4px', height: 'auto' }}
          >
            click here
          </Button>
          .
        </Text>
      </Stack>
    </Center>
  )
}

export default SignInPage
